module.exports = __webpack_public_path__ + "img/13.15b19a38.jpg";